import { request } from '../request';

export function fetchShiftsLocationFilters() {
  return request.get<string[]>('/v2/shifts/list-view/location-filters');
}

export function fetchShiftsQualificationFilters() {
  return request.get<
    {
      abbreviation: string;
      category: string;
      id: string;
      name: string;
    }[]
  >('/v2/shifts/list-view/qualification-filters');
}
